import { inject, Service } from '@angular/core';
import { StatusIncident } from '@portal-core/status-incidents/models/status-incident.model';
import { StatusIncidentsService } from '@portal-core/status-incidents/services/status-incidents.service';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';

@Service()
export class ActiveStatusIncidentProvider {
  private readonly statusIncidentsService = inject(StatusIncidentsService);

  private refreshSubject = new BehaviorSubject<void>(undefined);
  activeStatusIncident$: Observable<StatusIncident>;
  adminActiveStatusIncident$: Observable<StatusIncident>;

  constructor() {
    this.activeStatusIncident$ = this.refreshSubject.pipe(
      switchMap(() => this.statusIncidentsService.getActiveStatusIncident$())
    );
    this.adminActiveStatusIncident$ = this.refreshSubject.pipe(
      switchMap(() => this.statusIncidentsService.getActiveStatusIncidentAdmin$())
    );
  }

  onRefresh(): void {
    this.refreshSubject.next();
  }
}
